import { useEffect, useState } from 'react';
import { useData } from '../contexts/DataContext';
import type { SupportLiveMessage } from '../core/models/SupportLive';

/**
 * Real-time messages for houses/{houseId}/tickets/{ticketId}/messages.
 */
export function useTicketMessages(
  houseId: string | null | undefined,
  ticketId: string | null | undefined,
  enabled = true,
) {
  const { adapter } = useData();
  const [messages, setMessages] = useState<SupportLiveMessage[]>([]);

  useEffect(() => {
    if (!enabled || !houseId || !ticketId) {
      setMessages([]);
      return undefined;
    }
    if (!adapter.subscribeTicketMessages) {
      setMessages([]);
      return undefined;
    }
    return adapter.subscribeTicketMessages(houseId, ticketId, (rows) => {
      setMessages(rows as unknown as SupportLiveMessage[]);
    });
  }, [enabled, houseId, ticketId, adapter]);

  return { messages };
}
